import type { ActivityType } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  FieldSet,
  Legend,
  SelectionButton,
  SelectionButtons,
} from "@tandemdiabetes/sugarmate-react-components"
import type { ChangeEventHandler } from "react"
import { useMemo } from "react"

import styles from "./NoteInput.module.scss"
import { usePreviousNotes } from "./usePreviousNotes"
import { usePolyglot } from "src/contexts"

interface Props {
  value: string | null;
  onChange: ChangeEventHandler<HTMLInputElement>;
  activityType: ActivityType;
  subentryId?: string;
}

export function PreviousNotes(props: Props) {
  const polyglot = usePolyglot()

  const skipSubentries = useMemo(
    () => props.subentryId ? [props.subentryId] : [],
    [props.subentryId],
  )
  const previousNotes = usePreviousNotes(
    props.activityType,
    skipSubentries,
  )

  if (!previousNotes.length) {
    return null
  }

  return (
    <FieldSet>
      <Legend
        className={styles.legend}
        sizePreset="small"
      >
        {polyglot.t("components.entry_modal.previous_notes.label")}
      </Legend>
      <SelectionButtons>
        {
          previousNotes.map(
            (previousNote: string) => (
              <SelectionButton
                key={previousNote}
                htmlFor={previousNote}
                value={previousNote}
                onChange={props.onChange}
                checked={props.value === previousNote}
                id={"previous-note-button"}
              >
                {previousNote}
              </SelectionButton>
            ),
          )
        }
      </SelectionButtons>
    </FieldSet>
  )
}
